import { render, staticRenderFns } from "./Flipper.vue?vue&type=template&id=1ccfdad8&scoped=true"
import script from "./Flipper.vue?vue&type=script&lang=js"
export * from "./Flipper.vue?vue&type=script&lang=js"
import style0 from "./Flipper.vue?vue&type=style&index=0&id=1ccfdad8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d4iazq3oduqb2szvpffvlcs4f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccfdad8",
  null
  
)

export default component.exports